import { render } from "./TodoItems.vue?vue&type=template&id=78d85e3c"
import script from "./TodoItems.vue?vue&type=script&lang=js"
export * from "./TodoItems.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__